import {find} from "lodash";
import defaultOptions from "../config/ConfiguratorOptions";

const Sort = {
  get store() {
    return Spruce.store('configurator').listingSort
  },

  set store(store) {
    Spruce.store('configurator').listingSort = store
  },

  get defaultSortItems() {
    return JSON.parse(JSON.stringify(defaultOptions.sortItems))
  },

  toggle(name) {
    const oldSortItem = this.findSortSetting(name)
    const oldDirection = this.getSortDirection(name)

    this.resetSortOptions()

    this.appendOldSortItemIfNotExist(oldSortItem)
    this.toggleExistingSortOption(name, oldDirection)
    this.createSortOptionIfNotExist(name)
  },

  appendOldSortItemIfNotExist(item) {
    if (item && this.findSortSetting(item.key)) {
      return
    }

    this.store.push(item)
  },

  findSortSetting(name) {
    return find(this.store, {'key': name})
  },

  toggleExistingSortOption(name, oldDirection) {
    if (this.findSortSetting(name)) {
      this.store.map((item) => {
        if (item.key === name) {
          return item.direction = this.getOppositeSortDirection(oldDirection)
        }
      })
    }
  },

  getOppositeSortDirection(direction) {
    return direction === 'asc' ? 'desc' : 'asc'
  },

  resetSortOptions() {
    // this.store = this.defaultSortItems
    this.store = []
  },

  createSortOptionIfNotExist(name) {
    !this.findSortSetting(name) && this.setDefaultSortSetting(name)
  },

  getSortDirection(name) {
    const sorting = this.findSortSetting(name)
    return sorting?.direction ?? undefined
  },

  setDefaultSortSetting(name, direction) {
    this.store.push({'key': name, 'direction': direction ?? 'asc'})
  },

}

export default Sort
